import React from 'react';
import PropTypes from 'prop-types';
import ContractStatus from 'components/Credit24/SelfService/ContractStatus/ContractStatus';

const propTypes = {
  authentication: PropTypes.object,
  selfservice: PropTypes.object,
  isUpgradeHighlighted: PropTypes.bool,
  setUpgradeHighlightOff: PropTypes.func,
  setUpgradeSuccessOff: PropTypes.func,
  isInDashboard: PropTypes.bool,
  applyIncrease: PropTypes.func,
};

const ContractStatusWrapper = (props) => {
  const {
    authentication,
    selfservice,
    isUpgradeHighlighted,
    setUpgradeHighlightOff,
    setUpgradeSuccessOff,
    isInDashboard,
  } = props;
  const { isInCollection } = authentication;
  const { isNativeAdvertisingEnabled } = selfservice;
  const contractId = authentication.contracts[0];
  const contract = selfservice.contracts[contractId] || {};

  if (!contract.creditApplication) {
    return null;
  }

  const isContractFrozen = contract.CONTRACT_FREEZE && contract.CONTRACT_FREEZE.enabled;

  return (
    <ContractStatus
      contract={contract}
      isUpgradeHighlighted={isUpgradeHighlighted && isNativeAdvertisingEnabled}
      isUpgradeSuccess={selfservice.isUpgradeSuccess && isNativeAdvertisingEnabled}
      setUpgradeHighlightOff={setUpgradeHighlightOff}
      setUpgradeSuccessOff={setUpgradeSuccessOff}
      isInDashboard={isInDashboard}
      isNativeAdvertisingEnabled={isNativeAdvertisingEnabled}
      isContractFrozen={isContractFrozen}
      applyIncrease={props.applyIncrease}
      isApplyIncreaseLoading={selfservice.isApplyIncreaseLoading}
      isInCollection={isInCollection}
    />
  );
};

ContractStatusWrapper.propTypes = propTypes;

export default ContractStatusWrapper;
